import React, { useState, useEffect } from "react";

const isEmail = (email) => {
  const regex = /^([^\s@]+)@([^\s@]+\.[^\s@]+)$/;
  const match = email.match(regex);
  if (!match) return false;

  const domain = match[2];
  if (domain.endsWith(".de") || domain.endsWith(".com")) {
    return true;
  } else {
    return false;
  }
};

const MultiEmailField = ({
  label,
  id,
  delimiter = ";",
  icon,
  callbackFn = null,
  style,
}) => {
  const [emails, setEmails] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [inputError, setInputError] = useState("");

  useEffect(() => {
    if (callbackFn) {
      callbackFn(emails);
    }
    localStorage.setItem(id, JSON.stringify(emails));
  }, [emails, id, callbackFn]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setInputError("");
  };

  const addEmailsFromString = (emailString) => {
    const candidateEmails = emailString
      .split(new RegExp(`[${delimiter},\\s]+`))
      .map((email) => email.trim());
    const invalidEmails = candidateEmails.filter(
      (email) => !isEmail(email) && email !== ""
    );

    if (invalidEmails.length > 0) {
      setInputError(
        "Einige Einträge sind keine gültigen E-Mail-Adressen. Bitte überprüfen Sie diese und versuchen Sie es erneut."
      );
      return;
    }

    const validEmails = candidateEmails.filter(isEmail);
    setEmails((prevEmails) => [...new Set([...prevEmails, ...validEmails])]);
    setInputValue("");
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter" || e.key === delimiter) {
      e.preventDefault();
      addEmailsFromString(inputValue);
    }
  };

  const handleBlur = () => {
    addEmailsFromString(inputValue);
  };

  const removeEmail = (index) => {
    setEmails(emails.filter((_, i) => i !== index));
  };

  return (
    <div
      className="form-floating mb-1"
      style={{
        position: "relative",
        marginTop: "10px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <input
        type="text"
        id={id}
        className="form-control"
        placeholder={label}
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyDown}
        onBlur={handleBlur}
        style={style}
      />
      <label htmlFor={id} style={{ position: "absolute" }}>
        <i className={icon}></i> {label}
      </label>
      {inputError && (
        <div style={{ color: "#f1807e", marginTop: "10px" }}>{inputError}</div>
      )}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "5px",
          paddingTop: "0.5rem",
        }}
      >
        {emails.map((email, index) => (
          <span
            key={index}
            className="badge bg-custom-color"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              backgroundColor: "#ececec",
              color: "black",
              fontWeight: 450,
            }}
          >
            {email}
            <button
              type="button"
              onClick={() => removeEmail(index)}
              style={{
                cursor: "pointer",
                border: "none",
                backgroundColor: "transparent",
                color: "black",
                fontSize: "1rem",
              }}
            >
              ×
            </button>
          </span>
        ))}
      </div>
      {emails.length > 0 && (
        <div style={{ color: "#332885", marginTop: "10px" }}>
          Bitte überprüfen Sie die E-Mail-Adressen vor dem Absenden.
        </div>
      )}
    </div>
  );
};

export default MultiEmailField;
